module.exports = __webpack_public_path__ + "img/DAB-Profile-Rudiantara.9a899135.png";